import moment from "moment";
import { useState } from "react";
import { handleError } from "utils";
import defaultImage from "assets/images/staff-default-rounded.svg";
import {
  attachProfilePicFromChannelMembers,
  getDefaultProfileImage,
  getOtherChannelMembers,
  getOtherSendbirdMembers,
  parseChannelMembers,
  resolveMessengerGroupMemberCount,
} from "./channelData.helpers";
const useCustomChannelPreview = (dependencies) => {
  const [isDeleteConversationPopupOpen, setIsDeleteConversationPopupOpen] =
    useState(false);
  const [membersModal, setMembersModal] = useState(false);

  const {
    setCurrentChannel,
    currentChannel,
    currentUser,
    currentChannelUrl: activeChannelUrl,
    externalTabActive,
    handleProfileBtnClose,
  } = dependencies;

  const [actionInProgress, setActionInProgress] = useState(false);
  const [dropdownEllipsisOpen, setDropdownEllipsisOpen] = useState(false);
  const toggleEllipsis = (e) => {
    e.stopPropagation();
    setDropdownEllipsisOpen((prevState) => !prevState);
  };

  const handleArchiveChannel = async () => {
    if (!currentChannel) return;
    try {
      if (currentChannel.isHidden) {
        await currentChannel.unhide();
      } else {
        await currentChannel.hide(false, false);
      }
      setCurrentChannel(null);
    } catch (error) {
      handleError(error);
    }
  };

  const deleteChat = async () => {
    setActionInProgress(true);
    try {
      await currentChannel.markAsRead();
      await currentChannel.delete();
      setCurrentChannel(null);
    } catch (error) {
      handleError(error);
    }
    setActionInProgress(false);
    setIsDeleteConversationPopupOpen(false);
    handleProfileBtnClose();
  };
  const getChannelData = () => {
    try {
      if (currentChannel) {
        const { lastMessage, createdAt: channelCreatedAt } = currentChannel;
        const isActive = activeChannelUrl === currentChannel.url;
        const lastMessageTimeFromNow = moment().diff(
          moment(lastMessage?.createdAt || channelCreatedAt)
        );
        const duration = moment.duration(lastMessageTimeFromNow).get("days");
        const timeToShow =
          duration > 1
            ? moment(lastMessage?.createdAt).format("MMM D")
            : moment(lastMessage?.createdAt).format("h:mm A");

        const { memberCount, members, data, name, coverUrl } = currentChannel;
        let officeName = "";
        let channelName = name;
        let profilePic =
          coverUrl || defaultImage;
        let messageText = lastMessage?.message || lastMessage?.name;

        if (data && memberCount === 2) {
          const customMembers = parseChannelMembers(data);
          const otherCustomUser = getOtherChannelMembers(
            customMembers,
            currentUser?.id,
          )?.[0];
          const otherSendbirdMember = getOtherSendbirdMembers(
            members,
            currentUser?.id,
          )?.[0];
          // Never show peer office under the name in the chat list (all 1:1 types).
          officeName = "";
          channelName = externalTabActive
            ? channelName
            : otherSendbirdMember?.nickname;
          profilePic =
            otherSendbirdMember?.plainProfileUrl || getDefaultProfileImage();
          if (!channelName && otherCustomUser.name) {
            channelName = otherCustomUser.name;
          }
        }
        let groupMembers = [];
        if (data && memberCount > 2) {
          groupMembers = attachProfilePicFromChannelMembers(
            parseChannelMembers(data),
            currentChannel?.members || [],
          );
        }
        const displayMemberCount = resolveMessengerGroupMemberCount(
          memberCount,
          members,
          groupMembers,
        );

        return {
          officeName,
          channelName,
          channelImage: profilePic,
          messageText,
          isActive,
          timeToShow,
          groupMembers,
          displayMemberCount,
        };
      }
      return {};
    } catch {
      return {};
    }
  };

  const handleMembersClick = (e) => {
    e.stopPropagation();
    setMembersModal(!membersModal);
  };

  return {
    state: {
      dropdownEllipsisOpen,
      isDeleteConversationPopupOpen,
      actionInProgress,
      membersModal,
    },
    updateMethods: {
      setIsDeleteConversationPopupOpen,
      setMembersModal,
    },
    otherMethods: {
      handleArchiveChannel,
      toggleEllipsis,
      getChannelData,
      deleteChat,
      handleMembersClick,
    },
  };
};

export default useCustomChannelPreview;
